import { Toaster } from "sonner";
import { useTheme } from "next-themes";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { cn } from "@/lib/utils";

/**
 * Un solo <Toaster>: sonner 1.x, al vencer un toast, avisa a todos los
 * Toaster montados desde dentro de un setState; con dos (móvil y escritorio
 * ocultos por CSS) React advertía "Cannot update a component while rendering
 * a different component" cada vez que un toast desaparecía. La posición y el
 * tamaño cambian con el ancho de la pantalla.
 */
export function ThemeAwareToaster() {
  const { theme } = useTheme();
  const resolvedTheme = (theme as "light" | "dark" | "system") || "system";
  const isMobile = useMediaQuery("(max-width: 639px)");

  return (
    <div
      className={cn(
        "[&_[data-sonner-toaster]]:!w-fit [&_[data-sonner-toaster]]:!min-w-[250px] [&_[data-sonner-toast]]:!w-fit [&_[data-sonner-toast]]:!min-w-[250px]",
        isMobile
          ? "[&_[data-sonner-toaster]]:!max-w-[85vw] [&_[data-sonner-toaster]]:!left-1/2 [&_[data-sonner-toaster]]:!-translate-x-1/2 [&_[data-sonner-toaster]]:!right-auto [&_[data-sonner-toast]]:!max-w-[85vw]"
          : "[&_[data-sonner-toaster]]:!max-w-[560px] [&_[data-sonner-toast]]:!max-w-[560px]",
      )}
    >
      <Toaster
        richColors
        theme={resolvedTheme}
        visibleToasts={isMobile ? 3 : 6}
        position={isMobile ? "top-center" : "bottom-center"}
        toastOptions={{
          className: isMobile
            ? "!py-3 !px-3 !text-xs !gap-1 [&_[data-sonner-toast]]:!rounded-md [&_[data-content]]:!truncate [&_[data-title]]:!truncate"
            : // Compacto (al estilo de la barra bulk) y ajustado al contenido:
              // text-xs, íconos chicos, padding y ancho al contenido (w-fit).
              "!w-fit !py-2.5 !px-3 !gap-2 !text-xs [&_[data-sonner-toast]]:!rounded-md [&_[data-title]]:!text-xs [&_[data-title]]:!font-medium [&_[data-description]]:!text-xs [&_[data-icon]]:!size-4 [&_[data-icon]>svg]:!size-4",
        }}
      />
    </div>
  );
}
